export default __webpack_public_path__ + "static/media/5.db4d1ed1.svg";